import { format } from 'date-fns';

import { ChangeEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@mui/material';

import { DatePickerField } from '@/components/Form/DatePickerField';

import './ExtranetHandler.css';
import { useInitPreFolder } from './useInitPreFolder';

export const ExtranetHandler = () => {
  const { t } = useTranslation('easy_common');
  const { isLoading, mutate: initializeFolderAsync } = useInitPreFolder();
  const [crossingRequestedDate, setCrossingRequestedDate] = useState(format(new Date(), 'yyyy-MM-dd'));

  const initializeFoCaFolder = () => {
    initializeFolderAsync({ crossingRequestedDate, direction: 'FoCa' });
  };

  const initializeCaFoFolder = () => {
    initializeFolderAsync({ crossingRequestedDate, direction: 'CaFo' });
  };

  const handleChangeCrossingRequestDate = ({ target }: ChangeEvent<HTMLInputElement>) => {
    setCrossingRequestedDate(target.value);
  };

  return (
    <div className='extranet'>
      <h1>Extranet</h1>
      <DatePickerField
        sx={{ width: '400px' }}
        id='crossing-requested-date'
        label={t('easy.fakeExtranet.crossing.crossingRequestedDate.label')}
        value={crossingRequestedDate}
        onChange={handleChangeCrossingRequestDate}
      />
      <div className='card'>
        <Button
          sx={{ m: '1rem' }}
          variant='contained'
          disabled={isLoading || !crossingRequestedDate}
          onClick={initializeFoCaFolder}
        >
          {t('easy.fakeExtranet.crossing.FoCa.label')}
        </Button>
        <Button
          sx={{ m: '1rem' }}
          variant='contained'
          disabled={isLoading || !crossingRequestedDate}
          onClick={initializeCaFoFolder}
        >
          {t('easy.fakeExtranet.crossing.CaFo.label')}
        </Button>
      </div>
    </div>
  );
};
